module.exports = __webpack_public_path__ + "img/outcome_3.3ec0866a.gif";